const religionOptionsLib = [
  'Hindu',
  'Muslim',
  'Christian',
  'Sikh',
  'Parsi',
  'Jain',
  'Buddhist',
  'Jewish',
  'No Religion',
  'Spiritual',
  'Other',
]

const motherTongueOptionsLib = [
  {
    type: 'group',
    name: 'Frequently Used',
    items: [
      'Hindi',
      'Marathi',
      'Punjabi',
      'Bengali',
      'Gujarati',
      'Urdu',
      'Telugu',
      'Kannada',
      'English',
      'Tamil',
      'Oriya',
      'Marwari',
    ],
  },
  {
    type: 'group',
    name: 'More',
    items: [
      'Aka',
      'Arabic',
      'Arunachali',
      'Assamese',
      'Awadhi',
      'Baluchi',
      'Bengali',
      'Bhojpuri',
      'Bhutia',
      'Brahui',
      'Brij',
      'Burmese',
      'Chattisgarhi',
      'Chinese',
      'Coorgi',
      'Dogri',
      'English',
      'French',
      'Garhwali',
      'Garo',
      'Gujarati',
      'Haryanavi',
      'Himachali/Pahari',
      'Hindi',
      'Hindko',
      'Kakbarak',
      'Kanauji',
      'Kannada',
      'Kashmiri',
      'Khandesi',
      'Khasi',
      'Konkani',
      'Koshali',
      'Kumaoni',
      'Kutchi',
      'Ladakhi',
      'Lepcha',
      'Magahi',
      'Maithili',
      'Malay',
      'Malayalam',
      'Manipuri',
      'Marathi',
      'Marwari',
      'Miji',
      'Mizo',
      'Monpa',
      'Nepali',
      'Odia',
      'Pashto',
      'Persian',
      'Punjabi',
      'Rajasthani',
      'Russian',
      'Sanskrit',
      'Santhali',
      'Seraiki',
      'Sindhi',
      'Sinhala',
      'Sourashtra',
      'Spanish',
      'Swedish',
      'Tagalog',
      'Tamil',
      'Telugu',
      'Tulu',
      'Urdu',
      'Other',
    ],
  },
]

export { religionOptionsLib, motherTongueOptionsLib }
